import React from 'react';
import { steps } from '../data/steps';
export function HowItWorks() {
  return <section className="px-5 py-20 md:py-28" aria-labelledby="how-title" data-id="element-120" data-mp="7slq0yyp41rl">
      <div className="mx-auto grid max-w-6xl items-center gap-12 md:grid-cols-[1fr_1.1fr] md:gap-16" data-id="element-121" data-mp="7qsizik67fj2">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/4c427d23-f2e0-4e4b-8b3c-e3f7905a8f14.jpg" alt="Guitariste de jazz jouant sur une guitare archtop" className="aspect-[4/3] w-full rounded-2xl object-cover" data-id="element-122" data-mp="3q0umk5krjrqw" />
        <div data-id="element-123" data-mp="qiv1kzgdh5vy">
          <h2 id="how-title" className="font-display text-4xl uppercase leading-none text-cream md:text-6xl" data-id="element-124" data-mp="qild5gaz76sd">
            Imprimez. <span className="text-gold" data-id="element-125" data-mp="gtjutjgykdb8">Enseignez.</span> C’est tout.
          </h2>
          <ol className="relative mt-10 space-y-8 border-l border-ink-line pl-8" data-id="element-126" data-mp="grgt426g0vqo">
            {steps.map((s, i) => <li key={s.title} className="relative" data-id="element-127" data-mp="199ukpk16rlhb" data-mpi={i}>
                <span className="absolute -left-[45px] flex h-8 w-8 items-center justify-center rounded-full border border-gold bg-ink font-display text-sm text-gold" data-id="element-128" data-mp="19bffnarex6fp">
                  {i + 1}
                </span>
                <h3 className="font-serif text-2xl font-semibold text-cream" data-id="element-129" data-mp="2mki3lan16rm8">{s.title}</h3>
                <p className="mt-1 text-cream-muted" data-id="element-130" data-mp="31csbo9aa41r4">{s.description}</p>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}